<template>
    <div :class="{content: true,empty: list && list.length === 0,noTop: true}">
      <div class="list">
        <div class="handles">
          <div class="left">
            <div class="btn" @click="deleteAllPickUp">
              <img src="@assets/img/resources/del.svg" alt="delete">
              <span class="name">删除</span>
            </div>
          </div>
          <div class="btn greenBtn" @click="openAdd(2)">
            <img src="@assets/img/resources/add.svg" alt="add">
            <span class="name">添加</span>
          </div>
        </div>
        <div class="headline">
          <img :src="allChecked ? icons.checkerOn : icons.checker" alt="checker" class="checker" @click="checkAll()">
          <span class="number">素材名称</span>
          <span class="time">时长</span>
          <span class="start">发起时间</span>
          <span class="type">状态</span>
          <span class="handle">操作</span>
        </div>
        <empty :mTop="30" :msg="'暂无设备数据'" v-if="list && list.length === 0" />
        <div v-for="(l, i) in list" :key="i">
          <div :class="{content: true,on: l.checked}">
            <div class="item">
              <img :src="l.checked ? icons.checkerOn :icons.checker" alt="checker" class="checker" @click="checkItem(l)">
              <span class="number">{{l.title}}</span>
              <span class="time">{{l.duration}}</span>
              <span class="start">{{l.raw_add_time}}</span>
              <span :class="{type: true, g: l.res_status == 0, r: l.res_status == 2}">{{l.res_status == 0 ? '识别中' : l.res_status == 1 ? '识别完成' : '识别失败'}}</span>
              <span class="handle">
                <span v-if="l.res_status == 2" class="btn g" @click="convertWord(l)">
                  重新识别
                </span>
                <span v-if="l.res_status == 1" class="btn g" @click="startUse(l)">
                  剪辑
                </span>
                <span class="btn" @click="deletePickUp(l)">
                  删除
                </span>
              </span>
            </div>
          </div>
          <div class="childContent" v-if="l.expand">
            <div class="childItem" v-for="(c, ci) in l.todos" :key="ci + 1">
              <div class="theme" @click="goTypeDetail(c)">
                <span class="tag">{{c.type_name}}</span>
                <p class="words" @click="goTask(c)">
                  {{c.title}}
                </p>
              </div>
              <div class="cate">
                {{c.name}}
              </div>
              <div class="type">
                {{c.status_name}}
              </div>
              <div class="status">
                <span>{{c.start}}</span>
                <span>{{c.end}}</span>
              </div>
              <div class="borrower"></div>
              <div class="handle">
                <span v-if="c.status - 0 === 1" class="btn" @click="cancelTask(c.task_id)">取消</span>
                <span v-if="c.status - 0 === 2" class="btn" @click="finishTask(c.task_id)">结束</span>
              </div>
            </div>
            <div class="loan">
              <div class="btn" @click="openLoan(l)">
                <img src="@assets/img/resources/add.svg" alt="add">
                <span>外借</span>
              </div>
            </div>
          </div>
        </div>
        <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      </div>
      <addResource ref="addResource" />
      <equipmentLoan ref="equipmentLoan" />
      <stopUse ref="stopUse" />
    </div>
  </template>
  
  <script>
  import pages from '@components/pages'
  import addResource from '@components/addResource'
  import common from '@common/common'
  import {apis} from '@common/config'
  import equipmentLoan from '@components/equipmentLoan'
  import stopUse from '@components/stopUse'
  import empty from '@components/empty'
  import store from "@common/store";
  
  export default {
    name: 'equipments',
    components: {
      pages, addResource, equipmentLoan, stopUse, empty
    },
    watch: {
      randomDate: {
        handler(e) {
          if(e){
            if(this.timeInterval){
              clearTimeout(this.timeInterval)
              this.timeInterval = null
            }
            this.timeInterval = setTimeout(() => {
              this.page.pageIndex = 1;
              this.getList()
            }, 500);
          }
        },
        immediate: true,
        deep: true
      }
    },
    computed: {
      randomDate() {
        return this.$store.state.randomDate
      }
    },
    data() {
      return {
        timeInterval: null,
        page: {
          page_count: 0,
          pageIndex: 1,
          pageSize: 10,
          total: 0
        },
        icons: {
          checker: require('@assets/img/interview/checker.svg'),
          checkerOn: require('@assets/img/interview/checkerOn.svg'),
          up: require('@assets/img/topics/up.svg'),
          down: require('@assets/img/topics/down.svg')
        },
        filters: [],
        list: null,
        allChecked: false,
        filterOptions: {},
        filterType: null,
        borrow: {
          use: 0,
          total: 0
        },
        pie: {
          position: 'left',
          deg: 0
        }
      }
    },
    methods: {
      goTask(c) {
        if (c.relate_type != 0) return
  
        this.$router.push({
          path: '/interviewDetail',
          query: {
            r: c.relate_id
          }
        })
      },
      goTypeDetail(i) {
        // 去关联内容详情页
        console.log(1234, i)
      },
      getList() {
        // 获取设备列表
        const info = {
          page: this.page.pageIndex,
          pagesize: this.page.pageSize
        }
  
        // this.searchOptions.key_words = this.$store.state.keyWord
  
        Object.assign(info, this.searchOptions)
  
        common.myFetch(apis.getEditAudioList, info)
        .then((data) => {
          this.allChecked = false
          this.list = data.list
          this.generateSearchs(data.params.top_search.option.list);
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
        })
      },
      generateSearchs(data) {
        // 整理搜索栏数据
        const types = data.map(i => {
          return {
            name: i.title,
            code: i.key,
            selected: i.selected
          };
        });

        const filterData = {
          types: types,
          callback: o => {
            this.getSearch(o);
          }
        };
        this.postSearch(filterData);
      },
      getSearch(d) {
        // 接收搜索框数据
        this.searchOptions = d;
        this.page.pageIndex = 1;
        this.getList();
      },
      postSearch(data) {
        // 发送搜索框数据
        this.$emit("filterData", data);
      },
      calculatePie() {
        // 计算并绘制饼图
        const u = this.borrow.use        // 借出数
        const t = this.borrow.total      // 总数
        const r = (u/t)*100              // 系数
        // 默认（度数为0）时，遮罩（绿色）位于左侧，转头位于左侧（置于下方）
        if(r >= 50) {                    // 系数大于等50，转头置于上方，由180 - 360度旋转；遮罩（白色）位于右侧
          this.pie.position = 'left'
        } else {                         // 系数小于50，转头置于下方，由0 - 180度旋转；遮罩（绿色）位于左侧
          this.pie.position = 'right'
        }
  
        this.pie.deg = r * 3.6
      },
      getTasks(id, item) {
        // 获取设备相关任务
        const info = {
          device_id: id
        }
  
        return common.myFetch(apis.Res_device_tasks, info)
        .then((data) => {
          this.$set(item, 'todos', data.list)
        })
      },
      handleChecks(status) {
        // 删除／启用／停用 所选设备
        const ids = []
        this.list.forEach((d) => {
          if (d.checked) {
            ids.push(d.device_id)
          }
        })
        if (ids.length <= 0) {
          this.$toast('请选择设备')
          return
        }
  
        const idString = ids.join(',')
        this.useDevice(idString, status)
      },
      useDevice(id, status) {
        // 设备操作接口
        const info = {
          device_id: id,
          status: status // -1:删除，0:停用，1启用
        }
  
        common.myFetch(apis.Res_device_use, info)
        .then((data)=>{
          if (data) {
            this.$toast(data)
            this.getList()
          }
        })
      },
      cancelTask(id) {
        // 取消设备任务
        const info = {
          task_id: id
        }
        common.myFetch(apis.Res_device_task_cancel, info)
        .then((data) => {
          if (data) {
            this.$toast(data)
          }
        })
      },
      finishTask(id) {
        // 完成设备任务
        this.$refs.stopUse.open(id)
      },
      selectFilter(i, f) {
        // 选择筛选条件
        if (i.selected) return
  
        this.page.pageIndex = 1
  
        f.list.forEach((s) => {
          s.selected = false
        })
  
        this.$set(i, 'selected', true)
        if (i.class) {
          this.filterType = i.class
        }
        this.filterOptions[f.key] = i.key
        this.$nextTick(() => {
          this.getList()
        })
      },
      toggleExpand(l) {
        // 展开／关闭 设备任务列表
        if (!l.expand) {
          this.getTasks(l.device_id, l)
        }
  
        this.$set(l, 'expand', !l.expand)
      },
      goDetail(d) {
        // 跳转设备详情
        // this.$router.push({
        //   path: '/equipmentDetail',
        //   query: {
        //     d: d
        //   }
        // })
  
        common.jump(`/equipmentDetail?d=${d}`, true)
      },
      checkAll() {
        // 选择所有设备
        const status = !this.allChecked
  
        this.list.forEach((i) => {
          this.$set(i, 'checked', status)
        })
        this.allChecked = status
      },
      checkItem(i) {
        // 单选设备
        this.$set(i, 'checked', !i.checked)
  
        this.$nextTick(() => {
          if (!i.checked) {
            this.allChecked = false
          }
        })
      },
      openAdd(t) {
        // 添加设备弹窗
        let httpUpBtn334 = document.getElementById('httpUpBtn334')
        httpUpBtn334.click()
      },
      openLoan(l) {
        // 设备外借弹窗
        this.$refs.equipmentLoan.open({id: l.device_id, title: l.title, string: l.idstring})
      },
      async stopUse(l) {
        // 设备停用弹窗
        const c = await this.$confirm('确认停用吗？')
        if (!c) return
  
        // this.useDevice(l.device_id, 0)
      },
      async deleteAllPickUp() {
        const c = await this.$confirm('确认删除吗？')
        if (!c) return
        let arr = []
        this.list.forEach(el => {
          if(el.checked){
            arr.push(el.file_id)
          }
        })
        const info = {
          ids: arr.join(',')
        }
        common.myFetch(apis.deleteEditAudio, info)
        .then((data) => {
          if (data) {
            this.$toast(data)
            this.getList()
          }
        })
      },
      convertWord(f) {
        // 音视频转文字

        const info = {
            idstring: f.idstring,
            need_edit_audio: 1
        };

        common.myFetch(apis.File_convert, info).then(r => {
            if (r) {
              this.$toast(r)
              this.getList()
            }
        });
      },
      async deletePickUp(l) {
        const c = await this.$confirm('确认删除吗？')
        if (!c) return
        const info = {
          ids: l.file_id
        }
        common.myFetch(apis.deleteEditAudio, info)
        .then((data) => {
          if (data) {
            this.$toast(data)
            this.getList()
          }
        })
      },
      async startUse(l) {
        // let data = {
        //   type: l.type,
        //   id: l.file_id,
        //   create: store.state.create,
        //   canEdit: true,
        //   quickEdit: store.state.quickEdit
        // };
        // this.$materialBox(data);
        const newWindow = window.open();

        let s = 'undefined'
        let a = 'undefined'
        newWindow.location.href = `${window.location.origin
        }/voiceEdit/${s}/${a}/${l.idstring
        }`;

      }
    },
    mounted() {
      this.$DownloadMessage(true)
      this.$AudioDownloadMessage().then(res => {
        if(res == 'uploadComplete'){
          this.page.pageIndex = 1;
          this.getList()
        }
      })
      this.getList()
    },
    beforeDestroy() {
      this.$AudioDownloadMessage(true)
    }
  }
  </script>
  
  <style lang="less" src="@assets/css/resource/voiceRec.less" scoped></style>
  <style lang="less" scoped>
    .noTop {
        .list {
            margin-top: 0;
        }
    }
  </style>
  